export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
export const BEAMER_APP_ID = process.env.REACT_APP_BEAMER_APP_ID;

export const ESC_KEY = 27;
export const LEFT_KEY = 37;
export const RIGHT_KEY = 39;

export const myScheduleTabs = {
  pigMovements: 'pig-movements',
  treatments: 'treatments',
};

export const tableNames = {
  adminGroupShipments: 'adminGroupShipments',
  adminGroupTransfers: 'adminGroupTransfers',
  adminGroupScheduledLoads: 'adminGroupScheduledLoads',
  allCommitments: 'allCommitments',
  myScheduleArchive: 'myScheduleArchive',
  myScheduleTreatments: 'myScheduleTreatments',
  autoReports: 'autoReports',
  barnSheetsCompanies: 'barnSheetsCompanies',
  barnSheetsFarms: 'barnSheetsFarms',
  barnSheetsFarmGroups: 'barnSheetsFarmGroups',
  barnSheetsFarmReports: 'barnSheetsFarmReports',
  barnSheetsGroups: 'barnSheetsGroups',
  barnSheetsGroupsTPProductSteps: 'barnSheetsGroupsTPProductSteps',
  barnSheetsGroupSalesResults: 'barnSheetsGroupSalesResults',
  checkupGroupTPProductSteps: 'checkupGroupTPProductSteps',
  farmTreatmentProtocols: 'farmTreatmentProtocols',
  pigGroupCommitments: 'pigGroupCommitments',
  pigGroupTreatmentProtocols: 'pigGroupTreatmentProtocols',
  pigGroupTreatmentProtocolsProductSteps: 'pigGroupTreatmentProtocolsProductSteps',
  startPigGroupCommitments: 'startPigGroupCommitments',
  reportFarms: 'reportFarms',
  truckingCompanies: 'truckingCompanies',
  treatmentProtocolFarms: 'treatmentProtocolFarms',
  manageTreatmentProtocols: 'manageTreatmentProtocols',
  feedOrderFarms: 'feedOrderFarms',
  feedOrderFarmGroups: 'feedOrderFarmGroups',
  groupFeedOrders: 'groupFeedOrders',
  feedOrdersAll: 'feedOrdersAll',
  feedOrdersFarm: 'feedOrdersFarm',
  treatmentProtocolPigGroups: 'treatmentProtocolPigGroups',
  treatmentProtocolFarmGroups: 'treatmentProtocolFarmGroups',
  virtualVisits: 'virtualVisits',
  reportTemplates: 'reportTemplates',
  adminReportTemplates: 'adminReportTemplates',
  farmReports: 'farmReports',
  farmDraftReports: 'farmDraftReports',
  treatmentProtocols: 'treatmentProtocols',
};
